import { isNumber, isString, toNumber } from 'lodash-es';
import { UseReadContractReturnType } from 'wagmi';
import { abi } from '../ABIs/abi.ts';
import { blockchainTokensMapWithGroups } from './blockchain-consts.ts';
import { HorseName } from './racing-game/consts.ts';
import { StableName } from './racing-game/horses.ts';

type ShortenAddressConfig = {
  startChars?: number;
  endChars?: number;
};

/**
 * Shortens an Ethereum address by showing first N characters, three dots, and last N characters
 * @param address - Ethereum address to shorten
 * @param config - Optional configuration object
 * @param config.startChars - Number of characters to show from start (default: 4)
 * @param config.endChars - Number of characters to show from end (default: 4)
 * @returns Shortened address in format "0x12...abcd"
 */
export const shortenEthAddress = (address: string, config: ShortenAddressConfig = {}): string => {
  if (!address) {
    return address;
  }

  const { startChars = 4, endChars = 4 } = config;
  const minLength = startChars + endChars;

  if (address.length <= minLength) {
    return address;
  }

  return `${address.slice(0, startChars)}...${address.slice(-endChars)}`;
};

// Should be replaced with simply HorseName not to complicate the code
type TokenStringName = HorseName;
type TokenStringNameWithStable = TokenStringName | StableName;
type TokenNumberName = number;

export function getBlockchainCorrespondingToken(value: TokenStringNameWithStable): TokenNumberName;

export function getBlockchainCorrespondingToken(value: TokenNumberName): TokenStringNameWithStable;

// Should be refactored to get rid of A and B
export function getBlockchainCorrespondingToken(
  value: TokenStringNameWithStable | TokenNumberName
): TokenStringNameWithStable | TokenNumberName {
  if (isString(value)) {
    return blockchainTokensMapWithGroups.indexOf(value);
  } else {
    return blockchainTokensMapWithGroups[value];
  }
}

type GetRoundDataFromBlockchainResponseFn = {
  params: NonNullable<UseReadContractReturnType<typeof abi, 'getRoundData'>['data']>;
  result: {
    startPrices: readonly bigint[];
    endPrices: readonly bigint[];
    betAmounts: readonly bigint[];
    groupBetAmounts: readonly bigint[];
    totalBetsAmount: bigint;
    totalGroupBetsAmount: bigint;
    multipliers: readonly bigint[];
    feePercentage: bigint;
    completed: boolean;
  };
};

/*const [
  startPrices,
  endPrices,
  totalBetsAmount,
  totalGroupBetsAmount,
  betAmounts,
  groupBetAmounts,
  multipliers,
  startBlock,
  endBlock,
  completed,
  feePercentage,
] = data;*/

export const getRoundDataFromBlockchainResponse = (
  data: GetRoundDataFromBlockchainResponseFn['params']
): GetRoundDataFromBlockchainResponseFn['result'] => {
  const [
    startPrices,
    endPrices,
    totalBetsAmount,
    totalGroupBetsAmount,
    betAmounts,
    groupBetAmounts,
    multipliers,
    ,
    ,
    completed,
    feePercentage,
  ] = data;

  return {
    startPrices,
    endPrices,
    totalBetsAmount,
    totalGroupBetsAmount,
    betAmounts,
    groupBetAmounts,
    multipliers,
    completed,
    feePercentage,
  };
};

export const getBlockchainAmountValue = (value: unknown, fractionDigits = 6) => {
  if (isString(value)) return parseFloat(toNumber(value).toFixed(fractionDigits)).toString();
  if (isNumber(value)) return parseFloat(value.toFixed(fractionDigits)).toString();
  return '';
};
